@if (actionStack!.getValue('snSValiditeTemperatureEau') !== 0) {
  <app-small-tuile
    type="icon"
    icon="fa-kit fa-picto-teau"
    [title]="'dashboard.mesure' | translate"
    [mode]="getTemperatureContent()"
    (onPress)="this.openProductModal()"
  >
  </app-small-tuile>
}

@if (actionStack!.getValue('snISondeRxInstalle') === 1) {
  <app-small-tuile
    type="icon"
    icon="fa-kit fa-picto-rx"
    [title]="'P00032.card.RX' | translate"
    [mode]="actionStack!.getValue('snSMesureRxCompense') + 'mV'"
    (onPress)="this.openProductModal()"
  >
  </app-small-tuile>
}

@if (actionStack!.getValue('snISondePhInstalle') === 1) {
  <app-small-tuile
    type="icon"
    icon="fa-kit fa-picto-ph"
    [title]="'dashboard.ph' | translate"
    [mode]="
      (actionStack!.getValue('snSMesurePhCompenseDixieme') * 0.1).toFixed(1)
    "
    [modeColor]="
      choixPhCouleur(actionStack!.getValue('snSMesurePhCompenseDixieme') * 0.1)
    "
    (onPress)="this.openProductModal()"
  >
  </app-small-tuile>
}
